module.exports = __webpack_public_path__ + "static/media/logo-pindaremirim.b0080080.png";